import React from 'react';
import PropTypes from 'prop-types';

/**
 * ProfileTabs component for navigating different sections of a profile
 * @param {Object} props - Component props
 * @param {string} props.activeTab - Currently active tab
 * @param {Function} props.onTabChange - Callback for tab change
 * @param {boolean} props.showAbout - Whether to show About tab
 * @param {boolean} props.showExperience - Whether to show Experience tab
 * @returns {JSX.Element} ProfileTabs component
 */
const ProfileTabs = ({ activeTab, onTabChange, showAbout = true, showExperience = true }) => {
  // Define available tabs
  const tabs = [
    { id: 'posts', label: 'Posts' },
    { id: 'comments', label: 'Comments' },
    { id: 'communities', label: 'Communities' },
  ];
  
  // Add Experience tab if enabled
  if (showExperience) {
    tabs.push({ id: 'experience', label: 'Experience' });
  }
  
  // Add About tab if enabled
  if (showAbout) {
    tabs.unshift({ id: 'about', label: 'About' });
  }
  
  return (
    <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
      <div className="border-b border-gray-200">
        <nav className="flex flex-wrap">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`px-6 py-4 text-center text-sm font-medium ${
                activeTab === tab.id
                  ? 'text-blue-600 border-b-2 border-blue-600'
                  : 'text-gray-500 hover:text-gray-700 hover:border-gray-300 border-b-2 border-transparent'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>
    </div>
  );
};

ProfileTabs.propTypes = {
  activeTab: PropTypes.string.isRequired,
  onTabChange: PropTypes.func.isRequired,
  showAbout: PropTypes.bool,
  showExperience: PropTypes.bool,
};

export default ProfileTabs;